import React, { useEffect, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from 'react-router-dom';
import Langs, { Localize } from "../../app/lang/langs";
import styles from "./MedicalVisits.module.css";
import { ViewSelectButton } from "../../components/buttons/ViewSelectButton";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { FilterMatchMode } from "primereact/api";
import { doneVisitsStatuses, getAllMedicalVisits, medicalVisitsTypesOptions, upcomingVisitsStatuses } from "./medicalVisistsSlice";
import { Tag } from "primereact/tag";
import { checkPermission, getTagClass } from "../../app/utils/helpers";
import { Dropdown } from "primereact/dropdown";
import moment from "moment";
import ViewMedicalVisitModal from "./ViewMedicalVisitModal";
import { Calendar } from "primereact/calendar";
import exportIcon from "../../assets/images/export.png";
import exportIconFocus from "../../assets/images/exportFocus.png";
import ImageButton from "../../components/buttons/ImageButton";
import { config } from "../../app/utils/config";
import MobileMedicalVisitsView from "./mobile/MobileMedicalVisitsView";

export function MedicalVisitsView() {

    const dispatch = useDispatch()
    const mounted = useRef(null)
    const navigate = useNavigate()
    const urlParams = useParams()
    const dtVisits = useRef(null)

    const [selectedView, setSelectedView] = useState()
    const [selectedMedicalVisit, setSelectedMedicalVisit] = useState(null)
    const selectedTeamsIds = useSelector((state) => state.teams.selectedTeamsIds)
    const medicalVisits = useSelector((state) => state.medicalVisits.list)
    const [filters, setFilters] = useState(null)
    const isMobile = useSelector((state) => state.settings.isMobile)
    const [globalFilterValue, setGlobalFilterValue] = useState('')
    const viewsOptions = [
        { label: <Langs str='UPCOMING_VISTS' />, value: 0 },
        { label: <Langs str='DONE_VISTS' />, value: 1 }
    ]

    let warmthColors = ["#5e4fa2", "#3288bd", "#f46d43", "#66c2a5", "#d53e4f", "#9e0142", "green", "red"]

    useEffect(() => {
        if (urlParams.subView && viewsOptions[urlParams.subView]) {
            setSelectedView(urlParams.subView)
            initFilters()
        }
    }, [urlParams])

    useEffect(() => {
        if (!mounted.current) {
            mounted.current = true
            initFilters()
            dispatch(getAllMedicalVisits())
        }
    })

    const initFilters = () => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            nom: { value: null, matchMode: FilterMatchMode.CONTAINS },
            prenom: { value: null, matchMode: FilterMatchMode.CONTAINS },
            email: { value: null, matchMode: FilterMatchMode.CONTAINS },
            type: { value: null, matchMode: FilterMatchMode.EQUALS },
            team_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
            type_follow_up: { value: null, matchMode: FilterMatchMode.EQUALS },
            is_mid_career: { value: null, matchMode: FilterMatchMode.EQUALS },
            medical_center: { value: null, matchMode: FilterMatchMode.EQUALS },
            validation: { value: null, matchMode: FilterMatchMode.EQUALS },
            status: { value: null, matchMode: FilterMatchMode.EQUALS },
            conclusion: { value: null, matchMode: FilterMatchMode.EQUALS },
            theoretical_visit_date: { value: null, matchMode: FilterMatchMode.DATE_IS },
            planned_visit_date: { value: null, matchMode: FilterMatchMode.DATE_IS }
        })
        setGlobalFilterValue('')
    }

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    }

    const handleViewChange = (view) => {
        if (view != null) {
            let selectedTeamId = selectedTeamsIds[0]
            navigate(`/medicalVisits/${selectedTeamId}/${view}`)
        }
    }

    const exportFilteredData = () => {
        let subView = viewsOptions[selectedView]
        switch (subView.value) {
            case 0:
                dtVisits.current.exportCSV(true)
                break
            case 1:
                dtVisits.current.exportCSV(true)
                break
            default:
                break
        }
    }

    const renderHeader = () => {
        return (
            <div className="flex justify-content-between">
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-search" />
                    <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" />
                </IconField>
            </div>
        )
    }

    function viewMedicalVisitModal(row) {
        if (checkPermission(config.scopes.medicalVisits, config.permissionTypes.edit)) {
            setSelectedMedicalVisit(row.data)
        }
    }

    let scrollHeight = "calc(100vh - 280px)"
    switch (isMobile) {
        case 2:
            scrollHeight = "calc(100vh - 340px)"
            break
        case 3:
            scrollHeight = "calc(100vh - 270px)"
            break
        default:
            break
    }

    const statusItemTemplate = (option) => {
        let color = "black"
        if (selectedView == '1') {
            color = option == doneVisitsStatuses[1] ? "red" : "green"
        } else {
            let colorIndex = upcomingVisitsStatuses.indexOf(option)
            color = warmthColors[colorIndex]
        }
        if (option)
            return <label style={{ color }}>{Localize(option)}</label>
        return <div><Langs str={'Select'} /></div>
    }

    const typeItemTemplate = (option) => {
        if (option)
            return <Tag value={<Langs str={option} />} severity={getTagClass(option)} />
        return <div><Langs str={'Select'} /></div>
    }

    const statusRowFilterTemplate = (options) => {
        return (
            <Dropdown value={options.value}
                options={selectedView == '0' ? upcomingVisitsStatuses : doneVisitsStatuses}
                onChange={(e) => options.filterApplyCallback(e.value)}
                itemTemplate={statusItemTemplate}
                valueTemplate={statusItemTemplate}
                placeholder={<Langs str={"Select"} />}
                className="p-column-filter"
                showClear
                style={{ minWidth: '12rem' }}
            />
        )
    }

    const typeRowFilterTemplate = (options, key) => {
        return (
            <Dropdown value={options.value}
                options={medicalVisitsTypesOptions[key]}
                onChange={(e) => options.filterApplyCallback(e.value)}
                itemTemplate={typeItemTemplate}
                valueTemplate={typeItemTemplate}
                placeholder={<Langs str={"Select"} />}
                className="p-column-filter"
                showClear
                style={{ minWidth: '12rem' }}
            />
        )
    }

    const selectRowFilterTemplate = (options, key) => {
        return (
            <Dropdown value={options.value}
                options={medicalVisitsTypesOptions[key]}
                onChange={(e) => options.filterApplyCallback(e.value)}
                placeholder={<Langs str={"Select"} />}
                className="p-column-filter"
                showClear
                style={{ minWidth: '12rem' }}
            />
        )
    }

    const tagBodyTemplate = (rowData, key) => {
        if (rowData[key]) return <Tag severity={getTagClass(rowData[key])} value={Localize(rowData[key])} />
        return "-"
    }

    const statusBodyTemplate = (rowData, key) => {
        let color = "black"
        if (selectedView == '1') {
            color = rowData[key] == doneVisitsStatuses[1] ? "red" : "green"
        } else {
            let colorIndex = upcomingVisitsStatuses.indexOf(rowData[key])
            color = warmthColors[colorIndex]
        }
        return <label style={{ color }}>{Localize(rowData[key])}</label>
    }

    const dateBodyTemplate = (rowData, key) => {
        if (rowData[key]) {
            return moment(rowData[key]).format("DD/MM/YYYY HH:mm")
        }
        return "-"
    }

    const dateFilterTemplate = (options) => {
        return <Calendar value={options.value}
            onChange={(e) => options.filterCallback(e.value, options.index)}
            dateFormat="dd/mm/yy"
            placeholder="dd/mm/yyyy"
            mask="99/99/9999" />
    }

    const canAccessClientsTeams = checkPermission(config.scopes.clientsTeams)
    const teamBodyTemplate = (rowData) => {
        if (canAccessClientsTeams) {
            return (
                <a className={styles.linkStyle} onClick={() => navToTeam(rowData)}>{rowData.team_name}</a>
            )
        }
        return rowData.team_name
    }

    const navToTeam = (rowData) => {
        const encodedLabel = encodeURIComponent(rowData.team_name)
        navigate(`/clients/${selectedTeamsIds[0]}/1/${encodedLabel}`)
    }

    const medicalVisitsFilter = (visit) => {
        if (selectedView == 0)
            return !doneVisitsStatuses.includes(visit.status)
        return doneVisitsStatuses.includes(visit.status)
    }

    let date = moment().format("DD-MM-YYYY")
    const header = renderHeader()

    if (isMobile === 2) {
        return <MobileMedicalVisitsView />
    }

    return (
        <div>
            <div className="topMenu">
                <Row>
                    <Col lg={3}>
                        <span className="headerTitle">
                            {<Langs str="MEDICAL_VISITS" />}
                        </span>
                    </Col>
                    <Col lg={6} className='d-flex justify-content-center'>
                        <ViewSelectButton
                            options={viewsOptions}
                            selectedView={viewsOptions.find(o => o.value == selectedView)?.value}
                            onViewChange={handleViewChange}
                        />
                    </Col>
                    <Col lg={3} className='d-flex justify-content-end'>
                        <ImageButton
                            image={exportIcon}
                            imageFocus={exportIconFocus}
                            onClick={exportFilteredData}
                            active={true}
                            tooltip="Export"
                            width={32} />
                    </Col>
                </Row>
            </div>
            <div className={styles.bodyContainer}>
                <div className="bodyCard">
                    <DataTable value={medicalVisits && medicalVisits.filter(medicalVisitsFilter)}
                        ref={dtVisits}
                        exportFilename={`Visites_medicales_export_${date}`}
                        paginator
                        rowsPerPageOptions={[10, 25, 50]}
                        rows={25}
                        scrollable
                        scrollHeight={scrollHeight}
                        sortMode="single"
                        dataKey="id"
                        filters={filters}
                        header={header}
                        emptyMessage={Localize("No medical vists found.")}
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate={`{first} ${Localize("to")} {last} ${Localize("of")} {totalRecords}`}
                        selectionMode="single"
                        onRowDoubleClick={viewMedicalVisitModal}
                        onFilter={(e) => setFilters(e.filters)}
                    >
                        <Column field="nom" header={Localize("Family Name")} filter sortable style={{ minWidth: '10rem' }} />
                        <Column field="prenom" header={Localize("Name")} filter sortable style={{ minWidth: '10rem' }} />
                        <Column field="email" header={Localize("email")} filter sortable style={{ minWidth: '10rem' }} />
                        <Column field="status" sortable header={Localize("Status")} body={(e) => statusBodyTemplate(e, "status")} filter showFilterMatchModes={false} filterElement={statusRowFilterTemplate} style={{ minWidth: '12rem' }} />
                        <Column field="type" header={Localize("type")} sortable style={{ minWidth: '12rem' }} showFilterMatchModes={false} filter filterElement={(e) => selectRowFilterTemplate(e, "type")} />
                        <Column field="type_follow_up" header={Localize("type_follow_up")} sortable filter showFilterMatchModes={false} style={{ minWidth: '12rem' }} filterElement={(e) => selectRowFilterTemplate(e, "type_follow_up")} />
                        <Column field="team_name" body={teamBodyTemplate} header={Localize("team_name")} filter sortable style={{ minWidth: '9rem' }} showFilterMatchModes={false} />
                        <Column field="medical_center" header={Localize("medical_center")} filter sortable style={{ minWidth: '9rem' }} showFilterMatchModes={false} filterElement={(e) => selectRowFilterTemplate(e, "medical_center")} />
                        <Column field="conclusion" header={Localize("conclusion")} body={(e) => tagBodyTemplate(e, "conclusion")} filter sortable style={{ minWidth: '8rem' }} showFilterMatchModes={false} filterElement={(e) => typeRowFilterTemplate(e, "conclusion")} />
                        <Column field="is_mid_career" header={Localize("is_mid_career")} body={(e) => tagBodyTemplate(e, "is_mid_career")} filter showFilterMatchModes={false} sortable style={{ minWidth: '8rem' }} filterElement={(e) => typeRowFilterTemplate(e, "is_mid_career")} />
                        <Column field="validation" header={Localize("validation")} body={(e) => tagBodyTemplate(e, "validation")} filter showFilterMatchModes={false} sortable style={{ minWidth: '9rem' }} filterElement={(e) => typeRowFilterTemplate(e, "validation")} />
                        <Column field="theoretical_visit_date" body={(e) => dateBodyTemplate(e, "theoretical_visit_date")} dataType="date" header={Localize("theoretical_visit_date")} sortable filter style={{ minWidth: '12rem' }} filterElement={dateFilterTemplate} />
                        <Column field="planned_visit_date" body={(e) => dateBodyTemplate(e, "planned_visit_date")} dataType="date" header={Localize("planned_visit_date")} sortable filter style={{ minWidth: '12rem' }} filterElement={dateFilterTemplate} />
                    </DataTable>
                </div>
            </div>
            <ViewMedicalVisitModal selectedMedicalVisit={selectedMedicalVisit}
                onHide={() => setSelectedMedicalVisit(null)} />
        </div>
    )
}